import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['viewport'];

  connect() {
    this.update = () => {
      const viewport = this.viewportTarget;
      const remaining = viewport.scrollWidth - viewport.clientWidth - viewport.scrollLeft;
      this.element.toggleAttribute('data-overflow', viewport.scrollWidth > viewport.clientWidth + 1);
      this.element.toggleAttribute('data-scrollable-left', viewport.scrollLeft > 1);
      this.element.toggleAttribute('data-scrollable-right', remaining > 1);
    };
    this.resizeObserver = new ResizeObserver(this.update);
    this.observeSizes = () => {
      this.resizeObserver.disconnect();
      this.resizeObserver.observe(this.viewportTarget);
      Array.from(this.viewportTarget.children).forEach(child => this.resizeObserver.observe(child));
      this.update();
    };
    this.mutationObserver = new MutationObserver(this.observeSizes);
    this.mutationObserver.observe(this.viewportTarget, { childList: true });
    this.viewportTarget.addEventListener('scroll', this.update, { passive: true });
    this.observeSizes();
  }

  disconnect() {
    this.viewportTarget.removeEventListener('scroll', this.update);
    this.resizeObserver.disconnect();
    this.mutationObserver.disconnect();
    ['data-overflow', 'data-scrollable-left', 'data-scrollable-right'].forEach(name => this.element.removeAttribute(name));
  }

}
